<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" >
            <el-form-item label="고유 코드(8자리)" prop="pl_code">
              <el-input  v-model="ruleForm.pl_code":maxlength="8" :disabled="pl_idx!=''">
              </el-input>
            </el-form-item>
            <el-form-item label="라이센스 제목" prop="pl_title">
              <el-input v-model="ruleForm.pl_title"></el-input>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="submitForm('ruleForm')">{{ pl_idx ? '수정' : '등록' }}</el-button>
              <el-button @click="resetForm('ruleForm')">목록 </el-button>
            </el-form-item>
          </el-form>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';
  import sessionStorage from '@/mixins/sessionStorage';
  import {countryList} from "@/service/countryService";

  let params = {};
  export default {
    name: "LicenseDetail",
    components: {},
    mixins: [ VuxAlert,sessionStorage ],
    data() {
      return {
        userInfo : this.getUserInfo(),
        c_idx : 1,
        pl_idx : this.$route.params.pl_idx ? this.$route.params.pl_idx : '',
        category: [],
        ruleForm: {
          pl_code: '',
          pl_title: '',
          type :'pinostory'
        },
        rules: {
          pl_code: [
            { required: true, message: '필수 선택사항입니다.', trigger: 'blur' },
            { min: 8, max: 8, message: '8자로 입력해주세요', trigger: 'blur' }
          ],
          pl_title: [
            { required: true, message: '필수 입력사항입니다.', trigger: 'blur' }
          ],

        }
      };
    },
    mounted() {
      this.getCountryList();
      this.getDetail();
    },

    methods: {
      initData() {
        this.ruleForm = {
          pl_code: '',
          pl_title: '',
          type :'pinostory'
        }
        this.wr_id = this.$route.params.wr_id;
      },

      getCountryList(){
        this.$api.$user.getCountry()
          .then(res => { // 로그인 api 통신 후 결과 처리
            //let resultData = res.Data.result;
            // this.category = [{c_idx : 1 , CO_NAME_KOR : 'South Korea'},{c_idx : 2 , CO_NAME_KOR : 'Japan'}];
            this.category = countryList;
          });
      },
      getDetail(){
        if(this.pl_idx){
          const params = {  pl_idx : this.pl_idx ,type : 'pinostory' }
          this.$api.$license.getLicenseList(params).then( res => res.Data.Result).then(res => {
            if(res.Info.Type === 1) {
              this.ruleForm = {
                pl_code: res.List[0].pl_code,
                pl_title: res.List[0].pl_title,
              }
              this.c_idx = res.List[0].c_idx;
            }
          })
        }
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let params = this.ruleForm;
            this.ruleForm.c_idx = this.c_idx;
            this.ruleForm.type = 'pinostory';
            if(this.pl_idx){
              this.ruleForm.pl_idx = this.pl_idx;
              this.$api.$license.updateLicense(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1){
                  this.updateAlert();
                }else{
                  this.errorAlert(res.reason);
                }
              })
            }else{
              this.$api.$license.createLicense(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1){
                  let alertParams = {'element' : this };
                  this.saveAlert(alertParams);
                }else{
                  this.errorAlert(res.Info.reason);
                }
              })
            }
          } else {
            this.validateAlert();
            return false;
          }
        });
      },
      resetForm(formName) {
        window.history.back();
      }
    }
  }
</script>
